import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getSortedModelsByCoverage, getModelsDates, getResourceType } from "./selectors"
import { buildModelsCoverageRequest } from "./helpers"

export default createModule({
  view,
  externalProps: (state, props) => ({
    resourceType: getResourceType(state, props),
    resourceId: get(props, "resourceId"),
    account: state.global.selected.account,
    modelsDates: getModelsDates(state, props),
  }),
  required: ["account"],
  data: [{
    resource: "modelsAvailability",
    url: () => ({
      id: "models",
      query: "query { models { id, name, availability { currentDate, factorsStartDate, securitiesStartDate } } }",
    }),
  }, {
    resource: "modelsCoverage",
    url: buildModelsCoverageRequest,
  }],
  mapStateToProps: (state, props) => ({
    sortedModelsByCoverage: getSortedModelsByCoverage(state, props),
  }),
  actions: {
    openDialog: DialogCreators.open,
  },
})
